import { BRAND_FEATURES, isBrandFeatureEnabled } from '../../../../config/brand'

const COLUMN_DEFINITIONS = Object.freeze({
  status: {
    key: 'status', field: 'alarmJobStatus', header: 'label_status', visibility: 'status',
    style: {minWidth: '150px', flexGrow: 1},
  },
  started: {
    key: 'started', field: 'alarmJobStartDate', header: 'label_started', visibility: 'started',
    filterField: 'alarmJobStartDate', filterMatchMode: 'contains',
    style: {minWidth: '150px', flexGrow: 1},
  },
  ended: {
    key: 'ended', field: 'alarmJobEndDate', header: 'label_ended', visibility: 'going',
    filterField: 'alarmJobEndDate', filterMatchMode: 'contains',
    style: {minWidth: '100px', flexGrow: 1},
  },
  status2: {
    key: 'status2', field: 'alarmPointStatus', header: null, visibility: 'status',
    style: {minWidth: '100px', flexGrow: 1},
    headerClass: 'alarm-table-status-secondary', bodyClass: 'alarm-table-status-secondary',
  },
  alarmName: {
    key: 'alarmName', field: 'alarmPointName', header: 'label_Alarm_name', visibility: 'alarmName',
    style: {minWidth: '250px', flexGrow: 2},
  },
  alarmId: {
    key: 'alarmId', field: 'alarmPointId', header: 'label_alarm_id', visibility: 'alarmId',
    style: {minWidth: '200px', flexGrow: 1},
  },
  triggeredBy: {
    key: 'triggeredBy', field: 'triggeredBy', header: 'filter_triggeredby', visibility: 'triggeredBy',
    style: {minWidth: '150px', flexGrow: 1},
  },
  systemId: {
    key: 'systemId', field: 'alarmPointSysId', header: 'label_system_id', visibility: 'systemId',
    style: {minWidth: '50px', maxWidth: '80px', flexGrow: 1},
  },
})

const BASE_ORDER = ['status', 'status2', 'alarmName', 'triggeredBy', 'alarmId', 'started', 'ended', 'systemId']
const INSEL_ORDER = ['status', 'started', 'ended', 'status2', 'alarmName', 'alarmId', 'triggeredBy', 'systemId']

export function createAlarmTableColumns(context) {
  const insel = isBrandFeatureEnabled(BRAND_FEATURES.INSEL_ALARM_TABLE, context)
  const order = insel ? INSEL_ORDER : BASE_ORDER

  return order.map((key) => ({
    ...COLUMN_DEFINITIONS[key],
    ...(insel && key === 'status2' ? {header: 'Zustand', translateHeader: false} : {translateHeader: true}),
  }))
}

export function formatTriggeredBy(value, context) {
  if (isBrandFeatureEnabled(BRAND_FEATURES.INSEL_ALARM_TABLE, context) && value === 'Johnson M5iN') {
    return 'insel'
  }

  return value
}
